import * as _ from "lodash";
import * as log from "loglevel";

import { action, autorun, computed, observable, runInAction } from "mobx";
import { config } from "../config";
import { Agent } from "../services/agent";
import { App } from "./models/app";
import { Project } from "./models/project";
import { User } from "./models/user";
import { RootStore } from "./root-store";

export class AppStore {
	@observable apps: App[] = [];
	@observable loading = false;
	@observable saving = false;

	constructor(){
	}

	@action
	async loadApps(loadActions = true, forceReload = false){
		if(this.apps.length > 0 && !forceReload){
			log.debug("using cache");
			return;
		}

		this.loading = true;
		let appData = await Agent.Apps.all();

		if(loadActions){
			await RootStore.actionStore.loadActions();
		}

		runInAction(() => {
			this.apps = appData.map((result : any) => new App(result));
			if(loadActions){
				this.apps.forEach(app => {
					app.actions = RootStore.actionStore.findByAppId(app.id);
				});
			}
			this.loading = false;
		});
	}

	@action async create(app: App){
		let result = await Agent.Apps.create(app);

		return runInAction(() => {
			app.fromJSON(result);
			this.apps.push(app);
			return app;
		});
	}

	@action async save(app: App){
		if(app.id){
			let result = await Agent.Apps.save(app.id, app);

			return runInAction(() => {
				app.fromJSON(result);
				return app;
			});
		}
		else{
			return await this.create(app);
		}

	}

	@action async remove(app: App) {
		let result = await Agent.Apps.remove(app.id);
		runInAction(() => {
			this.loadApps();
		});
	}

	findByName(name: string): App {
		return _.find(this.apps.slice(), {"name": name});
	}

	findById(id: string): App {
		return _.find(this.apps.slice(), {"id": id});
	}
}



// WEBPACK FOOTER //
// ./src/stores/app-store.ts